import { mdiViewDashboardVariantOutline, mdiBellOutline, mdiRobotOutline } from '@mdi/js'
import { PRIVATE } from '@/plugins/acl/const'

export default [
  {
    subheader: 'dashboardHeader',
  },
  {
    title: 'dashboard',
    to: 'panel-dashboard',
    icon: mdiViewDashboardVariantOutline,
    resource: PRIVATE.DASHBOARD,
    action: 'read',
  },
  {
    title: 'reminders',
    to: 'panel-reminders',
    icon: mdiBellOutline,
    resource: PRIVATE.REMINDERS,
    action: 'read',
  },
  {
    title: 'aiAssistant',
    to: 'panel-ai-assistant',
    icon: mdiRobotOutline,
    resource: PRIVATE.AI_ASSISTANT,
    action: 'read',
  },
]
